import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux'
import { ROLES } from 'src/constants/auth';
import { getAuth } from 'src/redux/slices/auth';
import { isProfileRoute } from 'src/screens/shared/methods/isProfileRoute';

const useUserLogged = () => {
  const { superAdminUser, currentUser, currentAccount, superAdminToken } = useSelector(getAuth);
  const isSuperAdminOnlyLogged = !!(superAdminUser && !currentUser);
  const { t } = useTranslation();

  const SUPER_ADMIN_ONLY_ROLES = [{
    id: ROLES.SUPER_ADMIN, 
    name: t('accountScreen:super_admin')
  }, {
    id: ROLES.ADMIN, 
    name: t('accountScreen:admin')
  }, {
    id: ROLES.STAFF, 
    name: t('accountScreen:staff')
  }];

  const NORMAL_USER_ROLES = [{
    id: ROLES.APPADMIN, 
    name: t('accountScreen:appadmin')
  }, {
    id: ROLES.MANAGER, 
    name: t('accountScreen:manager')
  }, {
    id: ROLES.SELLER, 
    name: t('accountScreen:seller')
  }, {
    id: ROLES.PROMOTER, 
    name: t('accountScreen:promoter')
  }, {
    id: ROLES.FINANCE_MANAGER, 
    name: t('accountScreen:finance_manager')
  }];

  let roles: RoleType[] = [];

  if (isSuperAdminOnlyLogged && isProfileRoute()) {
    roles = SUPER_ADMIN_ONLY_ROLES;
  } else {
    roles = NORMAL_USER_ROLES;
  }

  return {
    isNormalUserLogged: currentUser && !superAdminUser,
    isSuperAdminOnlyLogged,
    isSuperAdminAsNormalUserLogged: superAdminUser && currentUser,
    superAdminUser,
    currentUser,
    currentAccount,
    superAdminToken,
    rolesByLoggedUser: roles
  };
};

export default useUserLogged;
